// react
import React, { Fragment, useEffect, useState } from "react";
// store
import { useSelector } from "react-redux";
import { authService } from "../../../store/services/ServiceAuth";
import { Role } from "../../../store/services/helpers/roles";
// components
import HeaderTitle from "../../../components/others/HeaderTitle";
import { adminPanes, providerPanes, userPanes, providerPanesForAdmin, providerPanesForManagedAccess } from "./ProfilePanes";
import { Tab } from "semantic-ui-react";
// others
import { GAPageView, initGA } from "../../../index";
// component
function Profile({ hasActiveSharedAccess }) {
    // state
    const [activeIndex, setActiveIndex] = useState(0);
    const user = useSelector(state => state?.user);

    // Google analytics
    useEffect(() => {
        initGA();
        GAPageView();
    }, []);

    // get tab from URL params
    useEffect(() => {
        const applyTab = () => {
            const tabParam = new URLSearchParams(window.location.search).get("tab");
            if (tabParam === "shared-access") {
                setActiveIndex(3);
            } else if (tabParam === "password") {
                setActiveIndex(1);
            } else {
                setActiveIndex(0);
            }
        };

        applyTab();
        window.addEventListener("profile-tab", applyTab);
        return () => window.removeEventListener("profile-tab", applyTab);
    }, []);

    // template
    return (
        <Fragment>
            <HeaderTitle title="Nastavenia profilu" />

            <section>
                <Tab
                    activeIndex={activeIndex}
                    onTabChange={(e, data) => {
                        const url = new URL(window.location);
                        url.searchParams.delete('tab');
                        window.history.pushState({}, '', url);
                        setActiveIndex(data.activeIndex);
                    }}
                    menu={{ fluid: true, style: { overflow: "auto" } }}
                    panes={
                        authService.useHasRole(Role.Admin)
                            ? adminPanes
                            : authService.useHasRole(Role.Provider)
                                ? user.original_admin?.id === undefined ? hasActiveSharedAccess ? providerPanesForManagedAccess : providerPanes : providerPanesForAdmin
                                : userPanes
                    }
                />
            </section>
        </Fragment>
    );
}

export default Profile;
